import { useSelector } from "react-redux";
import { selectDestinations } from "store/quote/selectors";
import { Destination, DestinationMore } from "./style";
import { useTranslation } from "react-i18next";

export function DestinationSection() {
  const destinations = useSelector(selectDestinations);
  const { t } = useTranslation("screens", { keyPrefix: "offer.tripDetails" });

  const destinationLabel =
    destinations?.[0]?.label +
    (destinations?.[0]?.country === "US"
      ? `, ${destinations[0]?.country}`
      : "");

  return (
    <Destination>
      {destinationLabel}
      {destinations?.length && destinations.length > 1 && (
        <DestinationMore>
          {t("moreThanOneDestination", {
            count: destinations.length - 1,
          })}
        </DestinationMore>
      )}
    </Destination>
  );
}
